module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/purple@2x.png?158759dc";